import React from 'react';
import BaseSection from 'commonComponents/sections/BaseSection/BaseSection';
import CheckList from 'commonComponents/CheckList/CheckList';
import { WhyInvestInClubDealsSectionImage } from '../images';
import styles from './WhyInvestInClubDealsSection.module.scss';

const WhyInvestInClubDealsSection = ({ content }) => {
  return (
    <BaseSection>
      <TextAndImage { ...content } />
    </BaseSection>
  );
};

const TextAndImage = ({ title, text, list }) => {
  return (
    <div className={ styles.TextAndImage }>
      <article className={ styles.text }>
        <a name='why-invest'></a>
        <h5>{ title }</h5>
        <p>{ text }</p>
        <CheckList list={ list } />
      </article>
      <figure className={ styles.image }>
        <img src={ WhyInvestInClubDealsSectionImage } />
      </figure>
    </div>
  );
};

export default WhyInvestInClubDealsSection;
